export class MatchHeight {

    constructor(selector, config = {})
    {
        this.selector = selector;
        this.config = config;
    }

    init()
    {
        [].concat(this.selector).forEach((item, index) => {
            $(item).matchHeight(this.config);
        });
    }

}

